



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({ components: { NewTranslation } })
export default class SocialShare extends Vue {
  @Prop(String)
  public socialShare!: string;

  @Prop(String)
  public title!: string;

  @Emit()
  public close(): void {}

  get networks() {
    return [
      {
        name: 'email',
        icon: 'envelope',
        displayText: 'Email',
      },
    ];
  }
}
